/* eslint-disable max-len */
import { Dispatch, SetStateAction, useState } from "react";
import { StaticDatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { useTranslate } from "react-admin";
import { CustomButton } from "./CustomButton";

const viewButtonStyle =
  "w-full h-[32px] flex justify-center sm:justify-start px-[16px] border-none items-center bg-mono-primaryLightBgColor font-['Inter'] font-[400] text-[14px] text-mono-primaryTextColor";
const activeViewButtonStyle =
  "w-full h-[32px] flex justify-center sm:justify-start px-[16px] border-none items-center bg-[#F8D1C0] font-['Inter'] font-[400] text-[14px] text-mono-black";

interface ArtistSingleCalendarDatesSelectProps {
  setCalendarsDate: Dispatch<SetStateAction<Dayjs | null>>;
  handleDatePopoverClose: () => void;
  selectedView: string;
  setSelectedView: Dispatch<SetStateAction<string>>;
}

const ArtistSingleCalendarDatesSelect = ({
  setCalendarsDate,
  handleDatePopoverClose,
  selectedView,
  setSelectedView
}: ArtistSingleCalendarDatesSelectProps) => {
  const translate = useTranslate();
  const dateFilterFromLocalStorage = localStorage.getItem(
    "ServiceCalendarDateFilter"
  );
  const parsedDateFilter =
    dateFilterFromLocalStorage !== null && dateFilterFromLocalStorage !== "null"
      ? dayjs(JSON.parse(dateFilterFromLocalStorage))
      : dayjs();
  const [value, setValue] = useState<Dayjs | null>(parsedDateFilter);
  const [activeView, setActiveView] = useState<string>("day");
  const offset = new Date().getTimezoneOffset();
  const hour = offset <= -720 ? 0 : offset >= 720 ? 16 : 12;
  return (
    <div className="bg-mono-primaryLightBgColor text-[22px] font-['OptimaLTStd'] font-[500] text-mono-primaryTextColor">
      <div className="flex flex-wrap sm:flex-nowrap">
        <div>
          <StaticDatePicker
            displayStaticWrapperAs="desktop"
            openTo="day"
            value={value}
            onChange={(newValue) => {
              setValue(newValue);
            }}
            sx={{
              backgroundColor: "#FAF9F7",
              "& .Mui-selected": {
                backgroundColor: "#F8D1C0 !important",
                color: "#000000 !important"
              },
              "& .MuiPickersDay-root:hover": {
                backgroundColor: "#F6F4F1"
              }
            }}
          />
        </div>
        <div className="flex flex-col w-full border-l border-[rgba(48,47,46,0.1)]">
          <button
            className={
              activeView === "day" ? activeViewButtonStyle : viewButtonStyle
            }
            onClick={() => {
              setActiveView("day");
            }}
          >
            {translate("common.day_view")}
          </button>
          <button
            className={
              activeView === "timeGridWeek"
                ? activeViewButtonStyle
                : viewButtonStyle
            }
            onClick={() => {
              setActiveView("timeGridWeek");
            }}
          >
            {translate("common.week_view")}
          </button>
          <button
            className={
              activeView === "dayGridMonth"
                ? activeViewButtonStyle
                : viewButtonStyle
            }
            onClick={() => {
              setActiveView("dayGridMonth");
            }}
          >
            {translate("common.month_view")}
          </button>
        </div>
      </div>
      <div className="flex justify-end items-center gap-[8px] border-t border-[rgba(48,47,46,0.1)] p-[12px]">
        <CustomButton
          text={translate("common.cancel")}
          variant="tertiary"
          onClick={() => {
            handleDatePopoverClose();
          }}
        />
        <CustomButton
          text={translate("common.done")}
          onClick={() => {
            if (value) {
              setCalendarsDate(
                dayjs(value.format())?.hour(hour).minute(0).second(0)
              );
              localStorage.setItem(
                "ServiceCalendarDateFilter",
                JSON.stringify(
                  dayjs(value.format())?.hour(hour).minute(0).second(0)
                )
              );
            }
            setTimeout(() => {
              setCalendarsDate(null);
            }, 0);
            setSelectedView(activeView);
            handleDatePopoverClose();
          }}
        />
      </div>
    </div>
  );
};

export default ArtistSingleCalendarDatesSelect;
